module.exports = __webpack_public_path__ + "img/filetype_xls.4d9aa3b9.png";